import { Classes, Dialog } from "@blueprintjs/core";
import { observer } from "mobx-react";
import { can } from "modules/session/auth/access";
import React from "react";
import func from "../../functionalities";
import { NewsStoreType } from "../../models/news-store";
import styles from "./VersionNewsDialog.module.scss";

interface VersionNewsDialogProps {
    store: NewsStoreType;
    version: string;
    access: string[];
}

interface VersionNewsDialogState {
    dismissed: boolean;
}

/**
 * Всплывающее окно с изменениями текущей версии.
 * Показывается один раз — при первом входе после обновления, если новость
 * «Новая версия {version}» ещё не прочитана текущим пользователем.
 * Старые непрочитанные версии не всплывают: сверяемся строго с текущей версией.
 */
class Widget extends React.Component<VersionNewsDialogProps, VersionNewsDialogState> {
    constructor(props: VersionNewsDialogProps) {
        super(props);
        this.state = { dismissed: false };
    }

    componentDidMount() {
        const { store, version, access } = this.props;

        if (!version || !can(func.INTERNAL_USER_ACCESS, access)) {
            return;
        }

        if (store.isEmpty) {
            store.loadFirstPage();
        }
    }

    get candidate() {
        const { store, version, access } = this.props;

        if (!version || !can(func.INTERNAL_USER_ACCESS, access)) {
            return undefined;
        }

        return store.items.find((n) => !n.read && n.name === `Новая версия ${version}`);
    }

    handleClose = () => {
        const news = this.candidate;
        if (news) {
            news.open();
        }
        this.setState({ dismissed: true });
    };

    render() {
        const news = this.candidate;

        if (!news || this.state.dismissed) {
            return null;
        }

        return (
            <Dialog
                title={news.name}
                icon="info-sign"
                canEscapeKeyClose={true}
                canOutsideClickClose={true}
                isOpen={true}
                onClose={this.handleClose}
                style={{ width: "700px" }}
                backdropClassName="standard"
                className="figma-dialog"
            >
                <div className={`${Classes.DIALOG_BODY} ${styles.body}`}>
                    <div className={styles.content} dangerouslySetInnerHTML={{ __html: news.text }} />
                </div>
            </Dialog>
        );
    }
}

export const VersionNewsDialog = observer(Widget);
